import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/base.scss'
import App from './containers/app/App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter as Router } from 'react-router-dom'
const root = ReactDOM.createRoot(document.getElementById('icon'))
root.render(
  <React.StrictMode>
    <Router basename={process.env.REACT_APP_BASE_PATH}>
      <App />
    </Router>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
